import { render, staticRenderFns } from "./OrderBadgePanel.vue?vue&type=template&id=7304128a&scoped=true"
import script from "./OrderBadgePanel.vue?vue&type=script&lang=js"
export * from "./OrderBadgePanel.vue?vue&type=script&lang=js"
import style0 from "./OrderBadgePanel.vue?vue&type=style&index=0&id=7304128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304128a",
  null
  
)

export default component.exports